module.exports = __webpack_public_path__ + "img/a.6d6ee4b2.jpg";